<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择仓库"
    top="5vh"
    width="800px"
  >
    <TableSelect
      ref="tableSelect"
      :filter="filter"
      :columns="columns"
      module="basic"
      url="warehouses/kingdee"
      @select="selectHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        warehouseName: "",
        warehouseNo: "",
      },
      columns: [
        {
          title: "仓库编号",
          key: "warehouseNo",
          width: 120,
          align: "center",
        },
        {
          title: "仓库名称",
          key: "warehouseName",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    selectHandle(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
      this.$nextTick(() => {
        this.$refs.tableSelect.loadData();
      });
    },
  },
};
</script>
